<template>
	<div id="usuario-adicionar">
		<ld-popup
			id="popup-adicionar-usuario"
			class="popup-usuario"
			:fullscreen="true"
			:active.sync="activePopup"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
			:closed="funcaoFechar"
		>
			<div class="flex justify-between w-full p-2 pb-5" slot="header">
				<div class="flex items-center flex-1">
					<div class="content-title flex flex-col items-start">
						<h2 class="title">Adicionar usuário</h2>
						<div
							v-if="
								usuario &&
									usuario.empresa &&
									usuario.empresa.nome
							"
							class="flex items-center"
						>
							<h4 class="text-base">
								{{ usuario.empresa.nome }}
							</h4>
						</div>
					</div>
				</div>
				<ld-button
					icon-pack="feather"
					icon="icon-x"
					size="large"
					color="dark"
					type="flat"
					@click="popupCancelarCadastro = true"
				></ld-button>
			</div>

			<vx-card>
				<form
					v-if="usuario"
					class="py-5 md:px-4"
					id="form-adicionar-usuario"
					@submit.prevent="adicionarUsuario"
				>
					<geral
						:usuario.sync="usuario"
						:foto.sync="usuario.foto"
						:fotoThumb.sync="usuario.fotoThumb"
						:nome.sync="usuario.nome"
						:cpf.sync="usuario.cpf"
						:email.sync="usuario.email"
						:telefone.sync="usuario.telefone"
						:dataNascimento.sync="usuario.dataNascimento"
						:cep.sync="usuario.cep"
						:logradouro.sync="usuario.logradouro"
						:numero.sync="usuario.numero"
						:complemento.sync="usuario.complemento"
						:bairro.sync="usuario.bairro"
						:cidade.sync="usuario.cidade"
						:estado.sync="usuario.estado"
						:removeError="removeError"
					/>

					<estrutura-permissao
						:empresa.sync="usuario.empresa"
						:empresas.sync="empresas"
						:perfil.sync="usuario.perfil"
						:gerenciados.sync="usuario.gerenciados"
						:removeError="removeError"
					/>

					<div class="flex flex-col-reverse md:flex-row flex-wrap justify-end md:p-5">
						<ld-button
							type="border"
							class="md:mr-4 md:w-auto md:mt-0 mt-2 w-full"
							@click="popupCancelarCadastro = true"
						>
							Cancelar
						</ld-button>
						<ld-button
							class="md:w-auto md:mt-0 mt-2 w-full"
							buttonType="submit">
							Adicionar usuário
						</ld-button>
					</div>
				</form>
			</vx-card>

			<ld-popup
				title="Cancelar cadastro?"
				:active.sync="popupCancelarCadastro"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja cancelar o cadastro do usuário? Se
					cancelar, todos os dados inseridos serão perdidos.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="cancelarCadastro"
							>Cancelar cadastro</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupCancelarCadastro = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Usuário adicionado"
				:active.sync="popupUsuarioAdicionado"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>
					O usuário "{{ usuario ? usuario.nome : "" }}" foi
					adicionado.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-32"
							color="primary"
							type="filled"
							@click="cadastroFinalizado"
							>OK</vs-button
						>
					</div>
				</div>
			</ld-popup>
		</ld-popup>
	</div>
</template>

<script>
import Geral from "../components/geral/Geral";
import EstruturaPermissao from "../components/estrutura_permissao/EstruturaPermissao";
import Usuario from "../../../models/Usuario";
import Empresa from "../../../models/Empresa";
import Perfil from "../../../models/Perfil";
import ErrorHelper from "../../../helpers/ErrorHelper";
import StringHelper from "../../../helpers/StringHelper";
import DateHelper from "../../../helpers/DateHelper";

export default {
	name: "UsuarioAdicionar",
	data() {
		return {
			usuario: null,
			popupCancelarCadastro: false,
			popupUsuarioAdicionado: false,
			limitParamEmpresa: 20,
			empresas: null,
			errors: null,
			tabGeralFields: ["cpf", "nome", "email"],
			tabEstruturaPermissaoFields: ["perfil"]
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		}
	},
	components: {
		Geral,
		EstruturaPermissao
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		}
	},
	methods: {
		setNovoUsuario() {
			this.usuario = new Usuario({
				empresa: new Empresa({}),
				perfil: new Perfil({}),
				gerenciados: []
			});
		},
		async getEmpresa() {
			if (this.empresaPk) {
				const empresa = await Empresa.getEmpresa(this.empresaPk);
				if (empresa) {
					this.usuario.empresa = empresa;
				}
			}
		},
		async getEmpresas() {
			if (!this.empresaPk) {
				const { empresas } = await Empresa.getEmpresas({
					limit: this.limitParamEmpresa
				});

				this.empresas = empresas.map(empresa => {
					return {
						text: empresa.nome,
						value: empresa.pk,
						perfis: empresa.perfis
					};
				});
			}
		},
		async getUsuario() {
			try {
				if (
					this.usuario &&
					this.usuario.cpf &&
					this.usuario.cpf.length == 11
				) {
					let usuario = await Usuario.getUsuarioPorCpf(
						this.usuario.cpf
					);

					if (usuario) {
						usuario = Usuario.fromMap({
							...this.usuario,
							...usuario
						});
						usuario.dataNascimento = DateHelper.convertDate(
							usuario.dataNascimento,
							null,
							"DD/MM/YYYY"
						);
						this.usuario = usuario;
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		async adicionarUsuario() {
			const loadingAdicionarUsuario = this.$vsloading({
				container: "#popup-adicionar-usuario",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			this.errors = null;

			try {
				if (this.empresaPk) {
					await Usuario.criar(this.usuario, this.empresaPk);
				} else {
					await Usuario.criar(this.usuario);
				}

				this.popupUsuarioAdicionado = true;
			} catch (error) {
				this.errors = error;
				ErrorHelper.renderFormError("#form-adicionar-usuario", error);
			} finally {
				loadingAdicionarUsuario.hide();
			}
		},
		removeError(field) {
			if (!this.errors) return null;
			if (!field) return null;

			const { fields_errors } = this.errors;

			if (fields_errors) {
				const newErrors = fields_errors.filter(field_error => {
					return field != field_error.field;
				});

				this.errors.fields_errors = newErrors;
			}
		},
		cancelarCadastro() {
			this.popupCancelarCadastro = false;
			this.activePopup = false;
		},
		cadastroFinalizado() {
			this.popupUsuarioAdicionado = false;
			this.activePopup = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			this.usuario = null;
			this.errors = null;

			const form = document.querySelector("#form-adicionar-usuario");
			ErrorHelper.cleanFormErrors(form);
		}
	},
	watch: {
		active() {
			if (this.active) {
				const loadingEmpresa = this.$vsloading({
					container: "#popup-adicionar-usuario",
					color: "#000000",
					backgroundColor: "#ffffffba",
					opacity: 1,
					width: 44,
					height: 44
				});

				this.setNovoUsuario();

				Promise.all([this.getEmpresas(), this.getEmpresa()])
				.catch(error => {
					console.error(error);
				})
				.finally(() => {
					loadingEmpresa.hide();
				});

			}
		},
		"usuario.cpf": function(novoCpf, cpf) {
			const oldCpf = StringHelper.alphanumericOnly(cpf);
			const newCpf = StringHelper.alphanumericOnly(novoCpf);

			if ((this.active && newCpf != oldCpf) || !cpf) {
				this.getUsuario();
			}
		}
	}
};
</script>

<style lang="scss" src="./usuario_adicionar.scss"></style>
